import { NO_TO_ADDRESS } from '@cxhub/shared'

// Pure logic for the Queue's "To Address" filter auto-select (App.jsx's own
// useEffect, keyed on [channelFilter, companyFilter, toAddressDirectory], and
// Clear filters) — extracted so it can be unit-tested with node --test (no
// React harness available), same convention suggestionActionInputs.js already
// uses for SuggestionPanel.jsx's own logic.
//
// Which company an address belongs to is decided by the MAILBOX that owns it,
// not by its email domain (docs/decisions.md, 2026-09-30).
// amsalesholds@1aauto.com is on the 1aauto.com domain but is an alias of the
// AM internal mailbox, so it belongs to AM. The directory comes from the
// server's mailbox registry (GET /api/conversations/m365-addresses, built by
// channels/m365/config.js's m365AddressDirectory()): { address, company,
// testMailbox, team, list } per address. A new mailbox or alias needs only its
// registry entry, and this rule follows automatically.
//
// Returns the INCLUDED set (2026-09-24 — this filter moved from exclude-style
// to include-style; see docs/decisions.md and repositories/conversations.js's
// own comment for why), never the shared test mailbox. The Queue toggles
// (2026-10-07) are company + team: 1A / AM select their company's addresses on
// Customer Service mailboxes. Support selects EVERY address in the directory
// (2026-10-13), because a contact transferred to Support keeps its original
// To address (service@…, a Customer Service mailbox), and the narrower preset
// (team-Support mailboxes and the Support list only) hid every transferred
// contact (prod 6455214, 6601710). The Support toggle itself
// (shared/src/queue-toggles.js, the server's queueTogglesSql()) still decides
// which contacts are Support contacts; this preset only stops hiding them.
// Combined selections are the union. The agent can still narrow the filter by
// hand; Clear filters re-applies this preset.
export function computeIncludeToAddress({ companyFilter, toAddressDirectory }) {
  const selected = new Set(companyFilter ?? [])
  const support = selected.has('Support')
  return (toAddressDirectory ?? [])
    .filter((entry) => {
      if (entry.testMailbox) return false
      if (support) return true
      const team = entry.team ?? 'customer_service'
      return selected.has(entry.company) && team === 'customer_service'
    })
    .map((entry) => entry.address)
}

// The preset the Queue applies: the addresses above plus the "No To address"
// option (NO_TO_ADDRESS, 2026-10-30), always ticked, so an email contact with
// no To address is never hidden by a preset. Prod contacts 5047459 and
// 9535116 sat open and unseen for weeks with no To address.
export function defaultIncludeToAddress(args) {
  return [NO_TO_ADDRESS, ...computeIncludeToAddress(args)]
}
